import {
  TextArea,
  TextAreaChangeEvent,
  TextAreaHandle,
} from "@progress/kendo-react-inputs";
import React, { FunctionComponent, useRef, useState } from "react";
import { Error, Hint } from "@progress/kendo-react-labels";
import { FieldRenderProps } from "@progress/kendo-react-form";
import { useReduxDispatch, useReduxSelector } from "../../../../redux/hooks";
import {
  SetDescription,
  SetTaggedDescription,
  SetTaggedUsers,
} from "../../../../slices/TicketSlice";
import { IMentionsProps, Mentions } from "../../../Common/Mentions/Mentions";
import { UserApi } from "../../../../redux/api/UserApi";
import { IMention } from "../../../../types/User/IMention";
import {
  IMentionsHandleOnChange,
  IMentionsHandleOnClick,
  MentionsHandleOnChange,
  DefaultMentionsHandleOnClick,
} from "../../../Common/Mentions/Handlers";
import { ShowMentions } from "../../../Common/Mentions/utils";

export const ticketDescId = "ticketDescId";

const Description: FunctionComponent<FieldRenderProps> = (formRenderProps) => {
  const { data } = UserApi.useGetMentionConfigQuery();
  const {
    validationMessage,
    value,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    customProp,
    ...others
  } = formRenderProps;

  const showValidationMessage = validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : "";

  const [atActivated, setAtActivated] = useState(-1);
  const [mentionsText, setMentionsText] = useState("");

  const containerRef = useRef<HTMLDivElement | null>(null);
  const textAreaRef = useRef<TextAreaHandle>(null);

  const TaggedUsers = useReduxSelector(
    (state) => state.newTicket.TaggedUsers
  );
  const Call_Desc = useReduxSelector(
    (state) => state.newTicket.ticket.Call_Desc
  );

  const dispatch = useReduxDispatch();
  const minChars = data ? data.Min_Chars - 1 : 0;

  function handleOnClick(person: IMention) {
    const required: IMentionsHandleOnClick = {
      dispatch: dispatch,
      SetDescription: SetDescription,
      SetTaggedDescription: SetTaggedDescription,
      SetTaggedUsers: SetTaggedUsers,
      TaggedUsers: TaggedUsers,
      setAtActivated: setAtActivated,
      setMentionsText: setMentionsText,
      mentionsText: mentionsText,
      textAreaRef: textAreaRef,
    };
    DefaultMentionsHandleOnClick(person, required);
  }

  function handleOnChange(e: TextAreaChangeEvent) {
    const eType = "TextAreaChangeEvent";
    const required: IMentionsHandleOnChange = {
      dispatch: dispatch,
      SetDescription: SetDescription,
      SetTaggedDescription: SetTaggedDescription,
      TaggedUsers: TaggedUsers,
      setAtActivated: setAtActivated,
      setMentionsText: setMentionsText,
      atActivated: atActivated,
      minChars: minChars.toString(),
    };
    MentionsHandleOnChange(e, eType, required);
  }

  const mentionsProps: IMentionsProps = {
    handleOnClick: handleOnClick,
    containerRef: containerRef,
    text: mentionsText,
  };
  return (
    <>
      {showValidationMessage && (
        <Error direction="start" id={errorId}>
          {validationMessage}
        </Error>
      )}
      <div ref={containerRef}>
        <TextArea
          id={ticketDescId}
          ref={textAreaRef}
          {...others}
          value={Call_Desc}
          maxLength={2000}
          rows={4}
          onChange={handleOnChange}
        />
      </div>
      {ShowMentions(mentionsText, minChars) && (
        <Mentions props={mentionsProps} />
      )}
      <Hint direction={"end"}>{Call_Desc?.length || 0} / 2000</Hint>
    </>
  );
};

export default Description;
